<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog @keydown.enter="login" max-width="500" persistent v-model="$store.getters.loginModal">
            <v-card>
                <v-card-title class="white--text primary">
                    <h4>Είσοδος</h4>
                </v-card-title>
                <br/>
                <v-form class="mx-2">
                    <v-row justify="center"  class="mx-auto pb-2">
                        <v-chip v-if="errorMessageFlag"  color="error">{{errorMessage}}</v-chip>
                    </v-row>
                    <v-text-field
                            class="pt-4"
                            :error="errorMessageFlag"
                            v-model="username"
                            label="Όνομα Χρήστη"
                            name="Username"
                            prepend-icon="person"
                    ></v-text-field>
                    <v-text-field
                            :error="errorMessageFlag"
                            v-model="password"
                            label="Κωδικός Πρόσβασης"
                            name="Password"
                            prepend-icon="lock"
                            :type="showPassWord ? 'text' : 'password'"
                            :append-icon="showPassWord ? 'visibility_off' : 'visibility'"
                            @click:append="showPassWord = !showPassWord"></v-text-field>
                    <v-card-actions>
                        <v-btn block class="white--text" color="primary" large primary @click="login()">ΣΥΝΔΕΣΗ</v-btn>
                    </v-card-actions>
                    <v-card-subtitle>
                        <p subtitle-2>Σε περίπτωση που ξεχάσατε το password πατήστε <a
                                href="https://submit.eudoxus.gr/">εδώ</a>.</p>

                    </v-card-subtitle>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import requests from '../requests'
    import utils from '../utilities'

    export default {
        name: "LoginModal",
        data() {
            return {
                dialog: true,
                asyncRequests:0,
                username: '',
                password: '',
                errorMessageFlag: false,
                errorMessage: '',
                homeInformation: {},
                showPassWord:false,
            }
        },
        methods: {
            login() {
                if (this.validateTextField()) {
                    this.$store.commit('setLoadingModal', true);
                    requests.login(this.username, this.password , this.loginCallBack, this.failedLoginCallBack);
                }
            },

            loginCallBack(response){

                this.errorMessageFlag = false;
                this.showPassWord = false;
                this.errorMessage = '';
                utils.setLocalStorage('lib_token', response);
                if (response == '') {
                    this.errorMessage = 'Username or Password is incorrect';
                    this.errorMessageFlag = true;
                    this.$store.commit('setLoadingModal', false);
                }
                else {
	                utils.createNavigationItem(response);
                    requests.get('rest/user/home', this.homePageInformationCallBack);
	                requests.get('rest/user/academic-years', this.yearsCallBack);
                    // requests.getYears(this.yearsCallBack);
                    // requests.getCouriers(this.couriersCallBack)
                    // requests.get('rest/app-info/publishers', this.getPublishersCallBack);
                    // requests.get('rest/app-info/prefectures', this.getPrefecturesCallBack);
                }
            },


            getPrefecturesCallBack(resp) {
                this.$store.commit('setPrefecturesForSelector', resp);
                //this.asyncRequests++;
            },

            getPublishersCallBack(resp){
                this.$store.commit('setPublishersForSelector', resp);
                //this.asyncRequests++;
            },


            failedLoginCallBack(response){
            	console.log(response)
				var messagePart = response.split(/{(.*)}/);
                if(messagePart[1] ==="not.authenticated"){
					this.errorMessage = messagePart[2];
				}else{
					this.errorMessage = 'Username or Password is incorrect';
                }
                this.errorMessageFlag = true;
                this.$store.commit('setLoadingModal', false);
            },

            homePageInformationCallBack(response) {
                this.$store.commit('setHomePageInformation', response);
                this.$store.commit('setLoadingModal', false);
	            this.$store.commit('setLoginModal', false);
	            this.asyncRequests++;

            },

            yearsCallBack(response) {
                this.$store.commit('setYearsInfo', response);
                this.asyncRequests++;
            },


            validateTextField() {
                this.errorMessageFlag = false;
                this.errorMessage = '';

                if (this.username.trim() == '') {
                    this.errorMessage = 'Username';
                    this.errorMessageFlag = true;
                }
                if (this.password.trim() == '') {

                    if (this.errorMessage != '') {
                        this.errorMessage += ' and Password';
                    }
                    else {
                        this.errorMessage = 'Password'
                    }
                    this.errorMessageFlag = true;
                }
                if (this.errorMessageFlag) {
                    this.errorMessage += ' is Required';
                    return false;
                }
                return true;
            }
        },
        watch: {
            'asyncRequests': function (val) {
                if (val === 2) {
                  this.$store.commit('setLoadingModal', false);
                  this.$store.commit('setLoginModal', false);
                  this.asyncRequests = 0;
                }
            },
        },
    }
</script>

<style scoped>

</style>